import React from "react";
import Routes from "./Routes";
import AuthProvider from "./contexts/AuthContext";
import TranslationContext from "./contexts/TranslationContext";
import ThemeProvider from "./contexts/ThemeContext";
import KpsPayCheckout from "./pages/KpsPayCheckout";

function App() {
  // Vérifie si l'URL ouverte est le guichet de paiement (/pay)
  const isKpsPayRoute =
    typeof window !== "undefined" &&
    window.location.pathname.replace(/\/+$/, "") === "/pay";

  return (
    <ThemeProvider>
      <TranslationContext>
        <AuthProvider>
          {isKpsPayRoute ? <KpsPayCheckout /> : <Routes />}
        </AuthProvider>
      </TranslationContext>
    </ThemeProvider>
  );
}

export default App;